import { CommonModule, NgIf } from '@angular/common'
import { Component, inject, OnDestroy, OnInit } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import { Store } from '@ngrx/store'
import {
  selectRevisedStatutoryCompliances,
  selectStatutoryCompliances
} from '../../../store/employee-salary/employee-salary.selectors'
import {
  addStatutoryCompliances,
  salaryRevisionActions
} from '../../../store/employee-salary/employee-salary.actions'
import { Observable, Subject, takeUntil } from 'rxjs'
import { ActivatedRoute } from '@angular/router'
import {
  SalaryMode,
  StatutoryCompliances
} from '../../../store/employee-salary/employee-salary.state'

@Component({
  selector: 'app-statutory-compliances',
  imports: [NgIf, FormsModule, CommonModule, ReactiveFormsModule],
  templateUrl: './statutory-compliances.component.html',
  styleUrl: './statutory-compliances.component.scss'
})
export class StatutoryCompliancesComponent implements OnInit, OnDestroy {
  private store = inject(Store)
  private route = inject(ActivatedRoute)
  private destroyed$ = new Subject<void>()
  private statutoryCompliances$!: Observable<StatutoryCompliances>
  private fb = inject(FormBuilder)
  currentMode!: SalaryMode
  salaryMode = SalaryMode
  form!: FormGroup
  constructor() {
    this.initializeForm()
  }

  ngOnInit(): void {
    this.currentMode = this.route.snapshot.data['mode'] as SalaryMode

    switch (this.currentMode) {
      case SalaryMode.CREATE:
        this.statutoryCompliances$ = this.store.select(selectStatutoryCompliances)
        break
      case SalaryMode.REVISE:
      case SalaryMode.UPDATE:
        this.statutoryCompliances$ = this.store.select(selectRevisedStatutoryCompliances)
        break
      default:
        throw new Error(`Unknown salary mode: ${this.currentMode}`)
    }

    this.statutoryCompliances$.pipe(takeUntil(this.destroyed$)).subscribe(complianceData => {
      if (complianceData) {
        this.form.patchValue(complianceData)
      }
    })
  }

  ngOnDestroy() {
    switch (this.currentMode) {
      case SalaryMode.CREATE:
        this.store.dispatch(addStatutoryCompliances({ statutoryCompliances: this.form.value }))
        break
      case SalaryMode.REVISE:
      case SalaryMode.UPDATE:
        this.store.dispatch(
          salaryRevisionActions.updateStatutoryCompliances({
            statutoryCompliances: this.form.value
          })
        )
        break
      default:
        throw new Error(`Unknown salary mode: ${this.currentMode}`)
    }

    this.destroyed$.next()
    this.destroyed$.complete()
  }

  initializeForm() {
    this.form = this.fb.group({
      pf: [false, Validators.required],
      eps: [false, Validators.required],
      employerCapping: [false, Validators.required],
      esi: [false, Validators.required],
      lwf: [false, Validators.required],
      pt: [false, Validators.required]
    })
  }

  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
    }
    return null // No error
  }
}
